import { resetCardPreloadBudget } from '~/composables/useCardPreloadBudget';

/**
 * "Sem evidencia de intencao NESTA TELA o teto especulativo e zero" (ver
 * useCardPreloadBudget) so vale por navegacao real. Sem este reset o sinal
 * era um latch de sessao inteira: uma unica interacao na home destravava o
 * teto especulativo de qualquer tela seguinte, sem nenhum sinal de intencao
 * ali. So em troca de path (nao query) — mesma tela com filtro novo continua
 * sendo a mesma tela.
 */
export default defineNuxtPlugin(() => {
	if (!import.meta.client) return;
	const router = useRouter();
	router.afterEach((to, from) => {
		if (to.path !== from.path) resetCardPreloadBudget();
	});
});
